module.exports = __webpack_public_path__ + "img/01.65adafa1.jpg";